import type { SVGAttributes } from "react";

export default function BdMiniFlagIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width="30"
      height="18"
      viewBox="0 0 30 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 0H30V18H0V0Z" fill="#207E7D" />
      <circle cx="13.5008" cy="8.99997" r="5.7" fill="#DF0000" />
    </svg>
  );
}
